
import { ActionTree } from 'vuex';
import PropertyFinanceStoresTypes from "./property-finance-types.store";
import { IPropertyEditState } from '../property-states.store';

const propertyFinanceActions: ActionTree<IPropertyEditState, {}> = <ActionTree<IPropertyEditState, {}>>{

  [PropertyFinanceStoresTypes.Set.CHARGE_ELEMENT]: (
        { commit },
        param: any
      ) => {
        commit(PropertyFinanceStoresTypes.Set.CHARGE_ELEMENT, param);
  },
  [PropertyFinanceStoresTypes.Set.UPDATE_NEW_PUBLIC_UTILITY]: (
    { commit },
    param: any
  ) => {
      commit(PropertyFinanceStoresTypes.Set.UPDATE_NEW_PUBLIC_UTILITY, param); 
  }  
}

export default propertyFinanceActions;